import { PLATFORM_LABEL } from '../lib/format.ts';
import type { Platform } from '../../../shared/types.ts';

/**
 * Glifos próprios e monocromáticos em vez dos logos oficiais: identificam a
 * rede sem trazer a marca de terceiro para dentro do painel, e herdam a cor
 * da plataforma definida nos tokens.
 */
function PlatformIcon({ platform }: { platform: Platform }) {
  if (platform === 'instagram') {
    return (
      <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false">
        <rect
          x="3.5"
          y="3.5"
          width="17"
          height="17"
          rx="5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <circle cx="12" cy="12" r="4" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="17" cy="7" r="1.3" fill="currentColor" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false">
      <rect
        x="3.5"
        y="3.5"
        width="17"
        height="17"
        rx="5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M14.2 12h-1.9v6h-2.3v-6H8.6V10h1.4V8.7c0-1.7 .9-2.7 2.9-2.7h1.6v2h-1c-.6 0-.8 .3-.8 .8V10h1.8l-.3 2z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PlatformBadge({
  platform,
  showLabel = true,
}: {
  platform: Platform;
  showLabel?: boolean;
}) {
  return (
    <span className={`platform-badge platform-badge--${platform}`}>
      <PlatformIcon platform={platform} />
      {showLabel && PLATFORM_LABEL[platform]}
    </span>
  );
}
